// ePOS SDK の ASB (Auto Status Back) ビットマスク定数
// SDK ソース epos-2.27.0.js より抽出
// NOTE: BATTERY_OFFLINE (=4) はバッテリ運用前提のビット。
// 弊社の TM-m30III は AC 給電のみで運用しているため、AC接続中でも常時立っている
// 可能性が確認されたため、誤検知ノイズになるので判定対象から除外している。
const ASB = {
  NO_RESPONSE: 1,
  OFF_LINE: 8,
  COVER_OPEN: 32,
  MECHANICAL_ERR: 1024,
  AUTOCUTTER_ERR: 2048,
  UNRECOVER_ERR: 8192,
  RECEIPT_NEAR_END: 131072,
  TOF_NOPAPER: 2097152,
  BOF_NOPAPER: 4194304,
  RECEIPT_END: 524288,
  SPOOLER_IS_STOPPED: 2147483648,
}

// eslint-disable-next-line no-bitwise
const has = (status, bit) => (status & bit) !== 0

/**
 * ePOS SDK の onreceive response.status (ビットマスク) から
 * ユーザ向け通知メッセージを生成する。該当条件がない場合は null。
 *
 * @param {number|undefined} status - ePOS SDK のステータスビットマスク
 * @param {string} [printerName='プリンタ'] - 表示するプリンタ名
 * @returns {{ level: 'error'|'warning', text: string }|null}
 */
export function getPrinterStatusMessage(status, printerName = 'プリンタ') {
  if (typeof status !== 'number') return null

  if (has(status, ASB.COVER_OPEN)) {
    return { level: 'error', text: `${printerName}: カバーを閉じてください` }
  }
  if (has(status, ASB.RECEIPT_END) || has(status, ASB.TOF_NOPAPER) || has(status, ASB.BOF_NOPAPER)) {
    return { level: 'error', text: `${printerName}: ロール紙を交換してください` }
  }
  if (has(status, ASB.OFF_LINE) || has(status, ASB.NO_RESPONSE)) {
    return { level: 'error', text: `${printerName}: 電源と接続を確認してください` }
  }
  if (
    has(status, ASB.AUTOCUTTER_ERR)
    || has(status, ASB.MECHANICAL_ERR)
    || has(status, ASB.UNRECOVER_ERR)
    || has(status, ASB.SPOOLER_IS_STOPPED)
  ) {
    return {
      level: 'error',
      text: `${printerName}: プリンタにエラーが発生しました。再起動して改善しない場合はサポートにご連絡ください`,
    }
  }
  if (has(status, ASB.RECEIPT_NEAR_END)) {
    return { level: 'warning', text: `${printerName}: ロール紙の残量が少なくなっています` }
  }

  return null
}
